











import { Component, Vue, Prop } from 'vue-property-decorator';

import { ImageSourceSet, Profile } from 'client-website-ts-library/types';
import { API } from 'client-website-ts-library/services';

@Component
export default class ContactBar extends Vue {
    private profile: Profile | null = null;

    mounted() {
      API.Profiles.Get('4518f67a-9551-4078-bda4-cc60df7ee953', true).then((profile) => {
        this.profile = profile;
      });
    }
}
